import ProductList from '@/pages/product/ProductList';
import ProductRegister from '@/pages/product/ProductRegister';
import ProductInquiry from '@/pages/product/ProductInquiry';
import SetCategory from '@/pages/category/SetCategory';
import ProductReqList from '@/pages/product/ProductReqList.vue';
import ProductReq from '@/pages/product/ProductReq.vue';
import IngredientList from '@/pages/product/IngredientList';
import IngredientManagement from '@/pages/product/IngredientManagement';
import EditorProductModify from '@/pages/product/EditorProductModify';
import EditorProductRegister from '@/pages/product/EditorProductRegister';
import EditorProductStatistics from '@/pages/product/EditorProductStatistics';
import EditorProductStatisticsDaily from '@/pages/product/EditorProductStatisticsDaily';
import DuplicatedProduct from '@/pages/product/DuplicatedProduct';
import MonthlyProductEdit from '@/pages/product/MonthlyProductEdit';
import AwardProductList from '@/pages/product/AwardProductList';
import CreateBeautyAwards from '@/pages/product/CreateBeautyAwards';
import ManageBeautyAwards from '@/pages/product/ManageBeautyAwards';
import ManageRankingModule from '@/pages/product/ManageRankingModule';
import AddRankingModule from '@/pages/product/AddRankingModule';
import ModifyRankingModule from '@/pages/product/ModifyRankingModule';
import ManagingKeyword from '../pages/product/ManagingKeyword.vue';

export default {
	ProductList: {
		id: 'ProductList',
		title: '제품 리스트',
		heading: '제품 리스트',
		path: '/product/product-list',
		component: ProductList,
	},
	ProductRegister: {
		id: 'ProductRegister',
		title: '신규 제품 등록',
		heading: '신규 제품 등록',
		path: '/product/product-register',
		component: ProductRegister,
	},
	ProductInquiry: {
		id: 'ProductInquiry',
		title: '제품 조회/수정',
		heading: '제품 조회/수정',
		path: '/product/product-inquiry/:idProduct',
		component: ProductInquiry,
	},
	SetCategory: {
		id: 'SetCategory',
		title: '제품 카테고리 관리',
		heading: '제품 카테고리 관리',
		path: '/category/set_category',
		component: SetCategory,
	},
	ProductReqList: {
		type: 'v3',
		id: 'ProductReqList',
		title: '제품관련요청',
		heading: '제품관련요청',
		parentName: '요청/신고',
		path: '/product/req-list',
		component: ProductReqList,
	},
	ProductReq: {
		type: 'v3',
		id: 'ProductReq',
		title: '',
		heading: '',
		parentName: '요청/신고',
		path: '/product/req/:staticCode',
		component: ProductReq,
	},
	IngredientList: {
		id: 'IngredientList',
		title: '성분 목록',
		heading: '성분 목록',
		path: '/product/ingredient-list',
		component: IngredientList,
	},
	IngredientManagement: {
		id: 'IngredientManagement',
		title: '성분 관리',
		heading: '성분 관리',
		path: '/product/ingredient-management',
		component: IngredientManagement,
	},
	EditorProductRegister: {
		id: 'EditorProductRegister',
		title: '추천제품 등록',
		heading: '추천제품 등록',
		path: '/product/editor-product/register',
		component: EditorProductRegister,
	},
	EditorProductModify: {
		id: 'EditorProductModify',
		title: '추천제품 조회/수정',
		heading: '추천제품 조회/수정',
		path: '/product/editor-product/modify/:productId',
		component: EditorProductModify,
	},
	EditorProductStatistics: {
		id: 'EditorProductStatistics',
		title: '추천제품 관리 통계',
		heading: '추천제품 관리 통계',
		path: '/prouct/editor-product/statistics/:productId',
		component: EditorProductStatistics,
	},
	EditorProductStatisticsDaily: {
		id: 'EditorProductStatisticsDaily',
		title: '추천제품 일별 관리 통계',
		heading: '추천제품 일별 관리 통계',
		path: '/prouct/editor-product/statistics/:productId/daily/:type',
		component: EditorProductStatisticsDaily,
	},
	DuplicatedProduct: {
		id: 'DuplicatedProduct',
		title: '중복 제품 관리',
		heading: '중복 제품 관리',
		path: '/product/duplicated-product',
		component: DuplicatedProduct,
	},
	MonthlyProductEdit: {
		id: 'MonthlyProductEdit',
		title: '인기 신제품 편집',
		heading: '인기 신제품 편집',
		path: '/product/monthly-product/edit/:itemId',
		component: MonthlyProductEdit,
	},
	MonthlyProductRegister: {
		id: 'MonthlyProductRegister',
		title: '인기 신제품 등록',
		heading: '인기 신제품 등록',
		path: '/product/monthly-product/register',
		component: MonthlyProductEdit,
	},
	AwardProductList: {
		id: 'AwardProductList',
		title: '어워드별 제품 리스트',
		heading: '어워드별 제품 리스트',
		path: '/product/award-product-list',
		component: AwardProductList,
	},
	CreateBeautyAwards: {
		id: 'CreateBeautyAwards',
		title: '뷰티어워드 관리',
		heading: '뷰티어워드 관리',
		path: '/product/beauty-awards',
		component: CreateBeautyAwards,
	},
	ManageBeautyAwards: {
		id: 'ManageBeautyAwards',
		title: '수상제품 관리',
		heading: '수상제품 관리',
		path: '/product/manage-awards/:category',
		component: ManageBeautyAwards,
	},
	ManageRankingModule: {
		id: 'ManageRankingModule',
		title: '랭킹모듈 관리',
		heading: '랭킹모듈 관리',
		path: '/product/manage-ranking-module',
		component: ManageRankingModule,
	},
	AddRankingModule: {
		id: 'AddRankingModule',
		title: '랭킹모듈 등록',
		heading: '랭킹모듈 등록',
		path: '/product/add-ranking-module',
		component: AddRankingModule,
	},
	ModifyRankingModule: {
		id: 'ModifyRankingModule',
		title: '랭킹모듈 수정',
		heading: '랭킹모듈 수정',
		path: '/product/modify-ranking-module/:idRanking',
		component: ModifyRankingModule,
	},
	ManagingKeyword: {
		id: 'ManagingKeyword',
		title: '키워드 관리',
		heading: '키워드 관리',
		path: '/product/managing-keyword',
		component: ManagingKeyword,
	},
};
